import { ISize } from '@picsart/web-layering/types';

import { WATERMARK_PATTERN_SIZE } from 'configs/constants';
import loadingImage from 'utils/images/loadingImage';

const QUALITY_FACTOR = 3;

const createWatermark = (img: HTMLImageElement, size: ISize): Promise<HTMLImageElement | null> => {
  const canvas = document.createElement('canvas');
  canvas.width = size.width * QUALITY_FACTOR;
  canvas.height = size.height * QUALITY_FACTOR;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return Promise.resolve(null);
  }
  const scale = Math.max((WATERMARK_PATTERN_SIZE * QUALITY_FACTOR) / img.width, (WATERMARK_PATTERN_SIZE * QUALITY_FACTOR) / img.height);
  const patternW = img.width * scale;
  const patternH = img.height * scale;
  for (let w = 0; w < canvas.width; w += patternW) {
    for (let h = 0; h < canvas.height; h += patternH) {
      ctx.drawImage(img, w, h, patternW, patternH);
    }
  }

  return loadingImage(canvas.toDataURL('image/png', 1));
};

export default createWatermark;
